import { useMutation } from '@redwoodjs/web'

import { toast } from 'src/components/Overlays/Toast/Toast'
import { useTaskModalContext } from 'src/context/TaskModalContext'
import { CREATE_ACTIVITY_LOG } from 'src/graphql/activityLogs.graphql'

import CallInput from './CallInput/CallInput'
import NoteInput from './NoteInput/NoteInput'
import SMSInput from './SMSInput/SMSInput'

const ActivityLogInput = ({
  applicantId,
  refetchQueries,
  communication = 'NOTE',
  onRegisterCall,
}) => {
  // Null outside the dashboard layout (tests, stories).
  const taskModal = useTaskModalContext()

  const [createActivityLog] = useMutation(CREATE_ACTIVITY_LOG, {
    refetchQueries,
    onCompleted: ({ createActivityLog }) => {
      if (onRegisterCall) {
        onRegisterCall(createActivityLog)
      }
      if (createActivityLog?.task) {
        taskModal?.callRefetch?.()
      }
    },
    onError: (error) => {
      // Try multiple paths to support both dev and production environments
      const errorMessage =
        error.graphQLErrors?.[0]?.extensions?.originalError?.message || // Dev environment (detailed errors)
        error.graphQLErrors?.[0]?.message || // Production environment (masked errors)
        error.message || // Final fallback
        'Something went wrong' // Default message
      toast(errorMessage, 'error')
    },
  })

  // Returned so the composer can clear itself only after a successful save.
  const onCreate = (values) => {
    return createActivityLog({
      variables: {
        input: {
          ...values,
          applicantId,
        },
      },
    })
  }

  if (communication === 'SMS') {
    return <SMSInput sendSMS={onCreate} applicantId={applicantId} />
  } else if (communication === 'NOTE') {
    return <NoteInput onCreate={onCreate} applicantId={applicantId} />
  }

  return <CallInput onCreate={onCreate} />
}

export default ActivityLogInput
